import { render, staticRenderFns } from "./memberCard.vue?vue&type=template&id=47012b05&scoped=true"
import script from "./memberCard.vue?vue&type=script&lang=js"
export * from "./memberCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47012b05",
  null
  
)

export default component.exports